import { io } from "socket.io-client";
import { GET_USER_AUTH_TOKEN } from "../common/auth";
import { API_URL } from "../common/constants";

class RealtimeService {
  realtime = {}; // change to object to hold multiple namespace connections

  connect(namespace = "/", onConnectCallback) {
    if (!this.realtime[namespace]) {
      this.realtime[namespace] = io(`${API_URL}${namespace}`, {
        transports: ["websocket"],
        auth: {
          Authorization: GET_USER_AUTH_TOKEN(),
        },
      });

      this.realtime[namespace].on("connect", () => {
        if (onConnectCallback && typeof onConnectCallback === "function") {
          onConnectCallback(this.realtime[namespace]);
        }
      });

      this.realtime[namespace].on("disconnect", () => {
        // Optionally log or handle disconnect
      });
    }

    return this.realtime[namespace];
  }

  getRealtime(namespace = "/") {
    return this.realtime[namespace];
  }

  disconnect(namespace = "/") {
    if (this.realtime[namespace]) {
      this.realtime[namespace].disconnect();
      delete this.realtime[namespace];
    }
  }

  disconnectAll() {
    Object.keys(this.realtime).forEach(ns => {
      this.realtime[ns].disconnect();
    });
    this.realtime = {};
  }
}

const REALTIME_SERVICES = new RealtimeService();

export { REALTIME_SERVICES };
